import React from "react"
import { getNavigationProps } from "@components/Navigation/getNavigationProps"
import { ParsedUrlQuery } from "querystring"
import InferNextPropsType from "infer-next-props-type"
import { GetStaticPropsContext } from "next"
import * as NextConstants from "../../../../src/constants/next"
import { NewsAPI } from "apis/NewsAPI"
import AuthorNews from "@components/News/AuthorNews/AuthorNews"
import { getSimplifiedNews } from "utils/news"

export default function AuthorPage({
  authorNews,
  pageNum,
  pages,
  authorCalciocomSlug,
  authorName,
}: InferNextPropsType<typeof getStaticProps>) {
  const onPageChange = (page: number) => {
    if (page === 1) {
      return `/autori/${authorCalciocomSlug}`
    } else {
      return `/autori/${authorCalciocomSlug}/${page}`
    }
  }

  return (
    <AuthorNews
      authorNews={authorNews}
      pageNum={pageNum}
      pages={pages}
      onPageChange={onPageChange}
      authorName={authorName}
    />
  )
}

export async function getStaticPaths() {
  return { paths: [], fallback: "blocking" }
}

interface IParams extends ParsedUrlQuery {
  authorCalciocomSlug: string
  pageNum: string
}

export async function getStaticProps(context: GetStaticPropsContext<IParams>) {
  try {
    const { pageNum } = context.params!
    const authorCalciocomSlug = context.params!.authorCalciocomSlug
    const [navigationProps, authorNews] = await Promise.all([
      getNavigationProps(),
      NewsAPI.getByAuthorSlugPaginated(authorCalciocomSlug, parseInt(pageNum)),
    ])
    const title = `Calcio.com - Articoli di ${authorNews.data[0].authorName}`

    const simplifiedNews = getSimplifiedNews(authorNews.data)
    const authorName = authorNews.data[0].authorName

    return {
      props: {
        title,
        pageNum: parseInt(pageNum),
        authorCalciocomSlug,
        pages: authorNews.pages,
        authorNews: simplifiedNews,
        authorName: authorName,
        navigationProps,
        seo: {
          title,
          description: title,
        },
        next: parseInt(pageNum) < authorNews.pages ? `/autori/${authorCalciocomSlug}/${parseInt(pageNum) + 1}` : null,
        prev: `/autori/${authorCalciocomSlug}/${parseInt(pageNum) - 1}`,
      },
      revalidate: NextConstants.REVALIDATE,
    }
  } catch (error) {
    console.error(error)
    return {
      notFound: true,
    }
  }
}
